import {
    ADD_INQUIRY_FAIL,
    ADD_INQUIRY_SUCCESS,
    DELETE_INQUIRY_FAIL,
    DELETE_INQUIRY_SUCCESS,
    DETAILS_LISTING_INQUIRY_FAIL,
    DETAILS_LISTING_INQUIRY_SUCCESS,
    GET_INQUIRY_DETAILS_FAIL,
    GET_INQUIRY_DETAILS_SUCCESS,
    GET_INQUIRY_LISTING_FAIL,
    GET_INQUIRY_LISTING_SUCCESS,
    RESET_INQUIRY_ATTACHMENT_STATE,
    RESET_INQUIRY_STATE,
    UPDATE_INQUIRY_FAIL,
    UPDATE_INQUIRY_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    inquiryListing: [],
    inquiryDetails: [],
    addInquiry: [],
    updateInquiry: [],
    deleteInquiry: [],
    detailListingInquiry: [],
    error: [],
}

const Inquiry = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_INQUIRY_LISTING_SUCCESS:
            return {
                ...state,
                inquiryListing: action.payload
            }
        case GET_INQUIRY_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_INQUIRY_DETAILS_SUCCESS:
            return {
                ...state,
                inquiryDetails: action.payload
            }
        case GET_INQUIRY_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_INQUIRY_SUCCESS:
            return {
                ...state,
                addInquiry: action.payload
            }
        case ADD_INQUIRY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_INQUIRY_SUCCESS:
            return {
                ...state,
                updateInquiry: action.payload
            }
        case UPDATE_INQUIRY_FAIL:
            return {
                ...state,
                error: action.payload,
                updateInquiry: action.payload,
            }

        case DELETE_INQUIRY_SUCCESS:
            return {
                ...state,
                deleteInquiry: action.payload
            }
        case DELETE_INQUIRY_FAIL:
            return {
                ...state,
                error: action.payload,
                deleteInquiry: action.payload
            }

        case DETAILS_LISTING_INQUIRY_SUCCESS:
            return {
                ...state,
                detailListingInquiry: action.payload
            }
        case DETAILS_LISTING_INQUIRY_FAIL:
            return {
                ...state,
                error: action.payload,
                detailListingInquiry: action.payload,
            }

        case RESET_INQUIRY_STATE:
            return {
                ...state,
                // inquiryListing: [],
                // inquiryDetails: [],
                addInquiry: [],
                updateInquiry: [],
                deleteInquiry: [],
                // detailListingInquiry: [],
                error: [],
            }
        case RESET_INQUIRY_ATTACHMENT_STATE:
            return {
                ...state,
                detailListingInquiry: [],
                error: [],
            }
        default:
            return state
    }
}

export default Inquiry
